import React from "react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";

const IMG =
  "https://images.unsplash.com/photo-1681108212545-04cabe9cf771?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGluZ290fGVufDB8fHx8MTc4Njg2MTAxM3ww&ixlib=rb-4.1.0&q=85&w=2000";

export default function PhysicalPlatinum() {
  return (
    <section id="platinum" className="w-full">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <Reveal>
          <div className="relative overflow-hidden rounded-[6px] border border-[#F0F1EE]/8">
            <img
              src={IMG}
              alt="Physical Platinum units"
              className="w-full h-[420px] sm:h-[520px] lg:h-[640px] object-cover"
              style={{ filter: "brightness(0.72) contrast(1.05)" }}
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(90deg, rgba(8,9,9,0.85) 0%, rgba(8,9,9,0.35) 45%, rgba(8,9,9,0.15) 100%)",
              }}
            />
            <div className="absolute inset-0 flex items-center">
              <div className="px-8 sm:px-14 lg:px-20 max-w-[620px]">
                <div className="flex items-center gap-3 mb-6">
                  {["unit-a", "unit-b", "unit-c"].map((id) => (
                    <span
                      key={id}
                      className="text-[11px] tracking-[0.2em] uppercase text-[#DADCD9]/80 border border-[#F0F1EE]/15 px-3 py-1.5"
                    >
                      10 mg
                    </span>
                  ))}
                </div>
                <h2 className="text-[34px] sm:text-[46px] lg:text-[58px] font-medium tracking-[-0.02em] leading-[1.03] text-[#F1F2EF]">
                  Measurable Platinum.
                  <br />
                  Precisely divided.
                </h2>
                <p className="mt-6 text-[15px] sm:text-[16px] leading-[1.6] text-[#A0A5A2] max-w-[440px]">
                  Each {CONFIG.token} represents exactly 10 milligrams of Platinum.
                  100 {CONFIG.token} represent one gram — physical value expressed
                  in precise digital units.
                </p>
                <div className="mt-8 flex items-center gap-6 text-[11px] tracking-[0.22em] uppercase text-[#B5BAB7]/70">
                  <span>XPTY</span>
                  <span className="text-[#6D726F]">·</span>
                  <span>Pt</span>
                  <span className="text-[#6D726F]">·</span>
                  <span>Platinum</span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
